import layout from '@/components/common/layout';
import lessonList from '../views/lesson/list';
import lessonCreate from "../views/lesson/create";

export default [
    {
        path: '/lesson',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "课程库列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'lesson_list',// 子选项
                    }
                },
                component: lessonList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增课程库",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'lesson_list',// 子选项
                    }
                },
                component: lessonCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑课程库",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'lesson_list',// 子选项
                    }
                },
                component: lessonCreate,
            },
        ]
    },
];
